import styled from "styled-components";
interface IAreaHeaderProps {
	showSupplierParts: boolean;
}

export const AreaHeader = styled.div<IAreaHeaderProps>`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: ${({ showSupplierParts }) => (showSupplierParts ? "stretch" : "flex-end")};
	width: 100%;
	gap: 0.4rem;
	padding: 0.8rem 0;
`;
export const WrapperHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	width: 100%;
	justify-content: center;
`;

export const AreaInfoPart = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	width: 100%;
	gap: 2rem;

	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		flex-direction: column;
		gap: 0.4rem;
	}
`;

export const WrapperCart = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	width: 100%;
	max-width: fit-content;
	margin-left: 1rem;

	.MuiSvgIcon-fontSizeLarge {
		font-size: 2.6rem;
	}
`;

export const SubtotalCart = styled.div`
	> p {
		margin: 0;
		color: #c4c4c4;
	}
	@media (max-width: 768px) {
		display: none;
	}
`;
export const SubtotalText = styled.span`
	font-size: 1.1rem;
	font-weight: bold;
`;

export const WrapperViewMode = styled.div`
	display: flex;
	margin-bottom: 5px;
	align-items: end;

	.active {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;
